<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">密推管理</div>
          <span class="m-title-s">对密推内容及音频新增、编辑等操作,排序按更新时间排序</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>密推列表
          </div>
          <div class="m-table-btn">
            <el-button @click="openPopup" type="primary" size="">新增密推</el-button>
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border size="mini">
          <el-table-column prop="title" label="标题" width=""></el-table-column>
          <el-table-column prop="status" label="状态" align="center" width="80">
            <template slot-scope="scope">
              <span v-text="scope.row.status === '0' ? '正常' : '关闭'"
                    :class="scope.row.status === '0' ? 'm-tips-blue' : ''">
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="explain" label="说明" width="" align="center"></el-table-column>
          <el-table-column prop="duration" label="音频时长" width="110" align="center">
            <template slot-scope="scope">
              <div>
                {{ formatTime(scope.row.duration) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="110" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="updateDate" label="修改时间" width="110" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="remarks" label="备注" align="center"></el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openForm(scope.row.id)" plain>编辑</el-button>
              <el-button type="danger" size="mini" @click="thisDel(scope.row.id)" plain>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="750px" center
               append-to-body :close-on-click-modal="false">
      <div class="m-open-container">
        <div class="zs-open-body-ov">
          <el-form :model="form" :rules="rules" ref="form" label-width="125px">
            <el-form-item label="音频标题: " prop="title">
              <el-input v-model="form.title" placeholder="输入音频标题"></el-input>
            </el-form-item>
            <el-form-item label="所属栏目: " prop="parentName">
              <el-input v-model="form.parentName" placeholder="输入所属栏目"></el-input>
            </el-form-item>
            <el-form-item label="密推音频：" prop="audioPath">
              <UploadAudio
                :music-id="'music'"
                v-if="openState"
                v-on:maxTime="getAudioDuration"
                v-on:audioSuccess="audioSuccess"
                v-on:handleAudioRemove="handleAudioRemove"
                :action="'audios/audio-secret/'"
                :accessKeys="accessKeys"
                :duration="form.duration"
                :nowAudioUrl="form.audioPath !== '' ? form.audioPath : ''"
              />
            </el-form-item>
            <el-form-item label="图标路径: " prop="icon">
              <el-input v-model="form.icon" disabled :rows="2" placeholder="输入图标路径"></el-input>
            </el-form-item>
            <el-form-item label="说明: " prop="explain">
              <el-input v-model="form.explain" type="textarea" :rows="2" placeholder="输入说明"></el-input>
            </el-form-item>
            <el-form-item label="设置状态: " prop="isStatus">
              <el-switch v-model="isStatus" active-text="开启" inactive-text="关闭"></el-switch>
            </el-form-item>
            <el-form-item label="备注: " prop="remarks">
              <el-input v-model="form.remarks" type="textarea" :rows="2" placeholder="输入备注"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;" v-loading="formLoading">
          <el-button @click="openState = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UploadAudio from '../public/UploadAudio.vue'

export default {
  name: 'SecretManage',
  data () {
    return {
      openText: '新增',
      openState: false,
      formLoading: false,
      isLoading: true,
      isStatus: true,
      list: [],
      fileList: [],
      editorOption: {},
      total: 0,
      pageNo: 1,
      ossUrl: this.$httpConf.ossURL,
      form: {
        id: '',
        title: '',
        parentName: '本期破秘推荐',
        duration: 0,
        audioPath: '',
        explain: '',
        status: '0',
        icon: 'images/secret/secret_icon.jpg',
        remarks: ''
      },
      accessKeys: {
        accessKeyId: '',
        accessKeySecret: '',
        bucket: '',
        region: '',
        audioName: ''
      },
      rules: {
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'}
        ],
        duration: [
          {required: true, message: '请输音频时长', trigger: 'blur'}
        ],
        parentName: [
          {required: true, message: '请输入所属栏目', trigger: 'blur'}
        ],
        audioPath: [
          {required: true, message: '请上传音频', trigger: 'blur'}
        ],
        explain: [
          {required: true, message: '请输入说明', trigger: 'blur'}
        ]
      }
    }
  },
  components: {
    UploadAudio
  },
  methods: {
    // 获取主音频时间
    getAudioDuration (e) {
      this.form.duration = Number(e.duration.toFixed(0))
    },
    // 删除音频
    handleAudioRemove (file, fileList) {
      this.form.audioPath = ''
    },
    // 主音频上传成功
    audioSuccess (res) {
      this.form.audioPath = res.url
    },
    // 分页
    handleCurrentChange (val) {
      this.pageNo = val
      this.listData()
    },
    closeDialog () {
      this.form = {
        id: '',
        title: '',
        parentName: '本期破秘推荐',
        duration: 0,
        audioPath: '',
        explain: '',
        status: '0',
        icon: 'images/secret/secret_icon.jpg',
        remarks: ''
      }
      this.openText = '新增'
      this.formLoading = false
    },
    openPopup () {
      this.openState = true
    },
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          _this.formLoading = true
          _this.form.status = _this.isStatus ? '0' : '1'
          this.$axios.post('/secret/save', _this.form)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.openState = false
                _this.formLoading = false
                _this.listData()
              } else {
                _this.$message.error(res.msg)
                _this.formLoading = false
              }
            })
        } else {
          return false
        }
      })
    },
    thisDel (id) {
      let _this = this
      this.$messageBox.confirm('此操作将永久删除当前项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/secret/del', {id: id})
          .then((res) => {
            if (res.status === 200) {
              _this.$message.success(res.msg)
              _this.listData()
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    openForm (id) {
      let _this = this
      this.openText = '编辑'
      _this.formLoading = true
      _this.openState = true
      this.$axios.post('/secret/form', {id: id})
        .then((res) => {
          if (res.status === 200) {
            _this.form = res.data
            _this.isStatus = res.data.status === '0'
            _this.formLoading = false
          } else {
            _this.$message.error(res.msg)
          }
        })
    },
    // 时间转换格式
    formatTime (time) {
      let it = parseInt(time)
      let m = parseInt(it / 60)
      let s = parseInt(it % 60)
      return (m < 10 ? '0' : '') + parseInt(it / 60) + ':' + (s < 10 ? '0' : '') + parseInt(it % 60)
    },
    // 管理员列表
    listData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/secret/list', {pageNo: _this.pageNo})
        .then((res) => {
          _this.list = res.data.rows
          _this.total = res.data.total
          _this.isLoading = false
        })
    },
    // 获取ossKey
    getUploadKey () {
      let _this = this
      this.isLoading = true
      this.$axios.post('/article/getUploadKey')
        .then((res) => {
          if (res.status === 200) {
            _this.accessKeys = res.data
          }
        })
    }
  },
  mounted () {
    this.listData()
    this.getUploadKey()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/platform/Secret.vue